import ChartPanel from '/components/statistics/chart-panel'
import FilterBar from '/components/statistics/filter-bar'
import PageShell from '/components/statistics/page-shell'
import useClientStatistics from '/components/statistics/use-client-statistics'

const adoptionChartSetting = {
  yAxis: [{ label: 'passes', width: 90 }]
}

const StatisticsAdoption = () => {
  const { loading, periodDays, setPeriodDays, selectableTemplates, statistics, templateId, setTemplateId } = useClientStatistics('adoption')

  return (
    <PageShell title="Statistics Adoption" heading="Statistics - Adoption">
      <div className='flex flex-col gap-5 mt-5 pb-20'>
        <FilterBar
          periodDays={periodDays}
          setPeriodDays={setPeriodDays}
          templateId={templateId}
          setTemplateId={setTemplateId}
          selectableTemplates={selectableTemplates}
          summaryItems={[
            { title: 'Active', value: statistics.extraTotals.activePasses },
            { title: 'Expired', value: statistics.extraTotals.expiredPasses },
            { title: 'Apple Installs', value: statistics.extraTotals.appleInstalls },
            { title: 'Google Installs', value: statistics.extraTotals.googleInstalls }
          ]}
        />

        <ChartPanel
          title='Template adoption'
          description='This compares live issued passes, currently active and expired passes, and installs on Apple and Google devices.'
          dataset={statistics.adoption}
          xAxis={{ scaleType: 'band', dataKey: 'template_name' }}
          series={[
            { dataKey: 'issued', label: 'Issued' },
            { dataKey: 'active_passes', label: 'Active' },
            { dataKey: 'expired_passes', label: 'Expired' },
            { dataKey: 'apple_installs', label: 'Apple installs' },
            { dataKey: 'google_installs', label: 'Google installs' }
          ]}
          loading={loading}
          height={520}
          yAxis={adoptionChartSetting.yAxis}
        />
      </div>
    </PageShell>
  )
}

export default StatisticsAdoption
